import { ITextStyle, Text } from '../../odie';
import { TextStyleId } from '../../defs/text';
import { textLocaleFormat } from '../util/textTools';

// types
//-----------------------------------------------------------------------------
export type BasicTextOptions = {
  text?: string;
  style?: TextStyleId;
  extraStyle?: Partial<ITextStyle>;
  literal?: boolean;
  system?: boolean;
};

/*
    basic text with localization
*/
export class BasicText extends Text {
  // init
  //-------------------------------------------------------------------------
  constructor(options: BasicTextOptions) {
    // const language = 'default';

    // // get font family for current language
    // const fontFamily = options.system ? systemFontMap[language] : languageFontMap[language].fontName;

    // // get text style
    // const style = new TextStyle({
    //     fontFamily,
    //     ...textStyles[options.style],
    //     ...options.extraStyle,
    // });

    const style = undefined;

    // get text
    const text = options.literal
      ? options.text
      : textLocaleFormat(options.text || '');

    // create text
    super(text!, style);
  }

  // api
  //-------------------------------------------------------------------------
  public setText(text: string, literal = false) {
    // update text
    super.text = literal ? text : textLocaleFormat(text);
  }

  public setColor(color: string) {
    this._innerView.color = color;
  }
}
